import { IGroup } from '@fluentui/react';
import { GroupByOption } from '../../../types';

/**
 * Takes a group and applies the "group name" to it either via an existing name
 * prop or by generating a name from the group key & onRenderGroupName prop.
 */
export const applyGroupNameToGroup = (
  group: IGroup,
  groupByOption: GroupByOption
) => {
  // If the group already has a name, we don't need to do anything.
  if (group.name) {
    return group;
  }

  // Note: We're intentionally ignoring "string" here to allow for groups that
  // have links in the title.
  const name = groupByOption.onRenderGroupName ? (
    <groupByOption.onRenderGroupName title={group?.key} />
  ) : (
    (group?.key as any)
  );

  return {
    ...group,
    name,
  };
};
